import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink, Route, Switch } from 'react-router-dom';//, Link, HashRouter as Router, 
import { authentication, session } from '../authentication';
import { Redirect } from 'react-router-dom';
import { ProjectLayout } from '../project/ProjectLayout';
import { config } from '../config';
import { openHelp } from '../actions/helpActions';
import Help from '../components/Help';
//import Modal from '../components/Modal';
import Preview from '../project/Preview';
import Publish from '../project/Publish';
import NewProject from './NewProject';
import ProjectSelection from './ProjectSelection';
import tbLogoOrange from '../assets/tbLogoOrange.png';
import Resources from '../project/Resources';
import ProjectSettings from '../project/ProjectSettings';

let Menu = (props) => {
    return (

        <nav className="navbar navbar-default navbar-fixed-top">
            <div className="navbar-header fix-top-left">
                <NavLink className="navbar-brand auth" to={`/Projects`}>
                    <img alt="Truebyte" src={tbLogoOrange} />
                </NavLink>
            </div>
            <div className="sidebar-offset">
                <ul className="nav navbar-nav navbar-right mr-0">
                    <li className="dropdown"><button href="#" className="btn-menulink">{props.user.name} <span className="caret"></span></button>
                        <ul className="dropdown-menu">
                            <li><a href={config.supportInbox} onClick={(e) => { e.preventDefault(); props.openHelp() }}>Help & Support</a></li>
                            <li role="separator" className="divider"></li>
                            <li><button href="#" className="btn-menulink"  onClick={props.logout}>Sign Out</button></li>
                        </ul>
                    </li>
                </ul>
            </div>
        </nav >
    )
}

Menu = connect(null, { openHelp })(Menu);

export class AuthLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: session.getUser()
        }
        this.logout = this.logout.bind(this);
    }

    logout() {
        authentication.logout();
    }

    render() {
        if (!this.state.user) {
            return <Redirect to={'/Login'} />
        }
        return (
            <div>
                <Menu user={this.state.user} logout={this.logout} />
                <Switch>
                    <Route exact={true} path="/NewProject" component={({ match }) => (<NewProject />)} />
                    <Route exact={true} path="/Projects" component={({ match }) => (<ProjectSelection />)} />
                    <Route exact={true} path="/:client/:project/ProjectSettings" component={({ match }) => (
                        <ProjectSettings
                            client={match.params.client}
                            project={match.params.project} />)} />
                    <Route exact={true} path="/:client/:project/Resources" component={({ match }) => (
                        <Resources
                            client={match.params.client}
                            project={match.params.project} />)} />
                    <Route exact={true} path="/:client/:project/Preview" component={({ match }) => (
                        <Preview
                            client={match.params.client}
                            project={match.params.project} />)} />

                    <Route exact={true} path="/:client/:project/Publish" component={({ match }) => (
                        <Publish
                            client={match.params.client}
                            project={match.params.project} />)} />
                    <Route path="/:client/:project" component={({ match }) => (<ProjectLayout client={match.params.client} project={match.params.project} />)} />
                </Switch>
                <Help />
            </div>);
    }
}